<template>
  <MAFieldWrapper
    v-slot="{ handleBlur }"
    :label="label"
    :value="modelValue as any"
    :disabled="disabled"
    :required="required"
    :readonly="readonly"
    :placeholder="placeholder"
    :rules="rules"
  >
    <component
      :is="MultiSelectVariant"
      v-model="fieldValue"
      :options="options"
      :option-label="optionLabel"
      :option-value="optionValue"
      :placeholder="placeholder"
      :loading="loading"
      :disabled="disabled"
      option-disabled="disabled"
      :filter="filter"
      :show-toggle-all="allowToggleAll"
      :filter-fields="['label', 'value']"
      :max-selected-labels="maxSelections"
      class="w-full"
      @blur="onBlur(handleBlur)"
    />
  </MAFieldWrapper>
</template>

<script setup lang="ts">
import type { DropdownOption } from "@/types/formData";
import MultiSelect from "@/volt/MultiSelect.vue";
import SoftMultiSelect from "@/volt/SoftMultiSelect.vue";
import MAFieldWrapper from "@/components/primevueComponents/MAFieldWrapper.vue";

const props = withDefaults(
  defineProps<{
    options: DropdownOption[];
    modelValue?: string | string[] | null;
    optionLabel?: string;
    optionValue?: string;
    placeholder?: string;
    allowToggleAll?: boolean;
    loading?: boolean;
    filter?: boolean;
    disabled?: boolean;
    maxSelections?: number;
    label?: string;
    required?: boolean;
    readonly?: boolean;
    rules?: Record<string, any>;
    variant?: "default" | "soft";
  }>(),
  {
    optionLabel: "label",
    optionValue: "value",
  }
);

const MultiSelectVariant = computed(() => {
  return props.variant === "soft" ? SoftMultiSelect : MultiSelect;
});

const emit = defineEmits(["update:modelValue", "blur"]);
const fieldValue = useVModel(props, "modelValue", emit);

function onBlur(cb: () => void) {
  if (cb) cb();
  emit("blur");
}
</script>
